/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-15",
    versionChannel: "nightly",
    buildDate: "2025-05-15T00:07:03.389Z",
    commitHash: "8d47e396c25ad18529dc23858e1c205a9637bbd3",
};
